import { CancelablePopupContent } from '@/components/CancelablePopup/type';

const presets: { [key: string]: CancelablePopupContent } = {
  removeWidget: {
    title: 'Remove app?',
    text: ' v',
    cancelText: 'Cancel',
    confirmText: 'Remove'
  },
  discard: {
    title: 'Discard changes?',
    text: 'Unsaved changes will be lost',
    cancelText: 'Keep editing',
    confirmText: 'Discard changes'
  },
  removeItem: {
    title: 'Remove item?',
    text: 'This item will be removed from selected items',
    cancelText: 'Cancel',
    confirmText: 'Remove'
  },
  removeAll: {
    title: 'Remove all?',
    text: 'All apps will be permanently deleted',
    cancelText: 'Cancel',
    confirmText: 'Remove'
  }
};

export default presets;
